import StickerType from "@/domains/Stickers/StickerType";
import RpcResponse from "@/core/services/Rpc/RpcResponse";
import RpcService from "@/core/services/Rpc/RpcService";

class StickerTypesDAO {
	static async get(
    filters: {
      stickerType: StickerType
    }
  ): Promise<RpcResponse> {
		return await RpcService.makeRequest('stickers.getType', filters);
	}

	static async getList(): Promise<RpcResponse> {
		return await RpcService.makeRequest('stickers.getTypesList');
	}

	static async add(stickers: StickerType[]): Promise<RpcResponse> {
		return await RpcService.makeRequest('stickers.addTypes', {stickers});
	}

	static async update(stickers: StickerType[]): Promise<RpcResponse> {
		return await RpcService.makeRequest('stickers.updateTypes', {stickers});
	}

	static async delete(stickerType: StickerType, reasonText: string): Promise<RpcResponse> {
		return await RpcService.makeRequest('stickers.deleteType', {stickerType, reasonText});
	}
}

export default StickerTypesDAO;
